import React from 'react';

/**
 * Minimalist empty-state slot for tables/lists with no rows.
 */
export const EmptyState = ({ icon: Icon, title, message, action, testid = 'empty-state' }) => (
  <div className="flex flex-col items-center justify-center text-center py-14 px-6" data-testid={testid}>
    {Icon && (
      <div className="w-12 h-12 rounded-xl bg-gray-100 flex items-center justify-center mb-4 text-gray-400">
        <Icon className="w-5 h-5" />
      </div>
    )}
    <h3 className="text-base font-semibold text-gray-900 mb-1">{title}</h3>
    {message && <p className="text-sm text-gray-500 max-w-sm">{message}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export default EmptyState;
